import { eCategory } from "../absenceTypes-model";
import { eSalerySystem } from "../institution-model";

// Categories whose whole-day absences should consume zero working time.
// DK: vacation, seniority and in-lieu time all map to "0 hours" days.
// Returned from a function so the eCategory enum is fully initialized before access
// (avoids circular-import ordering issues with absenceTypes-model.ts).
export function getDanishZeroDurationCategories(): eCategory[] {
  return [eCategory.Vacation, eCategory.Seniority, eCategory.InLieuTime];
}

// Codes for unplanned/acute absences (sickness etc.) per salary system —
// used by the dashboard and absence tag to colour-code unplanned vs. planned absence.
// Looked up inside the function so the eSalerySystem enum is fully initialized
// before access (avoids circular-import ordering issues via institution-model.ts → store).
export function getDanishNonePlannedCodes(
  salarySystem: eSalerySystem,
): string[] {
  switch (salarySystem) {
    case eSalerySystem.Manuel:
    case eSalerySystem.SD:
      return ["SYG", "SY-A", "SY", "HJ", "DS"];
    case eSalerySystem.KMD:
      return ["SYG", "SY", "HJ", "DS"];
    default:
      return [];
  }
}
